import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("lc_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("lc_cart", JSON.stringify(items));
  }, [items]);

  // Synchronise le panier côté serveur (permet le rappel de panier abandonné)
  useEffect(() => {
    if (!user) return;
    const t = setTimeout(() => {
      api.post("/cart", { track_ids: items.map((i) => i.track_id) }).catch(() => {});
    }, 800);
    return () => clearTimeout(t);
  }, [items, user]);

  const add = (track) => {
    if (items.some((i) => i.exclusive)) {
      toast.error("Votre panier contient une exclusivité : finalisez-la ou retirez-la d'abord");
      return;
    }
    setItems((prev) =>
      prev.some((i) => i.track_id === track.track_id) ? prev : [...prev, track]
    );
  };
  // L'exclusivité se paie seule : elle remplace le panier (confirmé côté appelant)
  const addExclusive = (track) =>
    setItems([{ ...track, exclusive: true, price: track.exclusive_price }]);
  const remove = (trackId) =>
    setItems((prev) => prev.filter((i) => i.track_id !== trackId));
  const clear = () => setItems([]);
  const total = items.reduce((s, i) => s + (i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, addExclusive, remove, clear, total }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
